import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const DocumentsIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M7.00031 6H13.0003M7.00031 9H13.0003M7.00031 12H10.0003M5.50008 2H14.5003C15.6048 2 16.5003 2.89545 16.5003 4.00004L16.5 16C16.5 17.1046 15.6046 18 14.5 18L5.49999 18C4.39542 18 3.49999 17.1045 3.5 15.9999L3.50008 3.99999C3.50008 2.89542 4.39551 2 5.50008 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

DocumentsIcon.displayName = 'DocumentsIcon';
